var _mask, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoCloseRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 16,
    viewBox: "0 0 16 16",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    height: 14,
    maskUnits: "userSpaceOnUse",
    width: 14,
    x: 1,
    y: 1
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m1.33333 8c0-3.67576 2.99091-6.66667 6.66667-6.66667 3.6758 0 6.6667 2.99091 6.6667 6.66667 0 3.6758-2.9909 6.6667-6.6667 6.6667-3.67576 0-6.66667-2.9909-6.66667-6.6667zm9.30607 2.6393c.1182-.1182.1182-.3121 0-.4303l-2.2091-2.20908 2.2091-2.20909c.1182-.11818.1182-.31212 0-.43031-.1182-.11818-.3121-.11818-.4303 0l-2.2091 2.20909-2.20909-2.20909c-.11818-.11818-.31212-.11818-.43031 0-.11818.11819-.11818.31213 0 .43031l2.2091 2.20909-2.2091 2.20908c-.11818.1182-.11818.3121 0 .4303.06061.0576.13637.0879.21516.0879.07878 0 .15454-.0303.21515-.0879l2.20909-2.20908 2.2091 2.20908c.0606.0576.1364.0879.2151.0879.0788 0 .1546-.0303.2152-.0879z",
    fill: "#fff",
    fillRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m1.33333 8c0-3.67576 2.99091-6.66667 6.66667-6.66667 3.6758 0 6.6667 2.99091 6.6667 6.66667 0 3.6758-2.9909 6.6667-6.6667 6.6667-3.67576 0-6.66667-2.9909-6.66667-6.6667zm9.30607 2.6393c.1182-.1182.1182-.3121 0-.4303l-2.2091-2.20908 2.2091-2.20909c.1182-.11818.1182-.31212 0-.43031-.1182-.11818-.3121-.11818-.4303 0l-2.2091 2.20909-2.20909-2.20909c-.11818-.11818-.31212-.11818-.43031 0-.11818.11819-.11818.31213 0 .43031l2.2091 2.20909-2.2091 2.20908c-.11818.1182-.11818.3121 0 .4303.06061.0576.13637.0879.21516.0879.07878 0 .15454-.0303.21515-.0879l2.20909-2.20908 2.2091 2.20908c.0606.0576.1364.0879.2151.0879.0788 0 .1546-.0303.2152-.0879z",
    fill: "#5d6677",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m0 16h16v-16h-16z",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCloseRound);
export default __webpack_public_path__ + "static/media/ico_close_round.c0e28a254ec0bbbae1fe9f67c14d12be.svg";
export { ForwardRef as ReactComponent };